module.exports = __webpack_public_path__ + "assets/redpack-clock-pointer-a334f923.gif";